export default {
    state: {
        itemTypes: [],
    },
    mutations: {
        setItemTypes(state, itemTypes) {
            state.itemTypes = itemTypes
        },
    },
    getters: {
        listItemTypes: state => state.itemTypes,
        findItemType: state => id => state.itemTypes.find(itemType => itemType.id === id)
    },
    actions: {
        loadItemTypes(context) {
            window.axios.get('/api/item-types')
                .then(({ data }) => {
                    context.commit('setItemTypes', data)
                })
                .catch(error => console.error(error))
        },
    }
}
